import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDotsHorizontal = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "dots",
	"data-name": "dots",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			className: "plan2plate-icon",
			cx: 3.41,
			cy: 12,
			r: 1.91
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "plan2plate-icon",
			cx: 12,
			cy: 12,
			r: 1.91
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "plan2plate-icon",
			cx: 20.59,
			cy: 12,
			r: 1.91
		})
	]
});
const ForwardRef = forwardRef(SvgDotsHorizontal);
export default ForwardRef;
